import i18next from 'i18next';
import i18nextXHRBackend from 'i18next-xhr-backend';

const i18nInstance = i18next.createInstance().use(i18nextXHRBackend);

export default async function i18n({
  locale = 'en',
  staticsBaseUrl = '',
  localeDatasetDataStaticsUrl,
} = {}) {
  const appTranslations = `${staticsBaseUrl}assets/locale`;
  const localeDatasetDataTranslations =
    localeDatasetDataStaticsUrl && `${localeDatasetDataStaticsUrl}translations`;
  return new Promise((res, rej) => {
    i18nInstance.init(
      {
        lng: locale,
        defaultNS: appTranslations,
        fallbackLng: 'en',
        keySeparator: '$',
        interpolation: {
          escapeValue: false,
        },
        backend: {
          loadPath: `{{ns}}/messages_{{lng}}.json`,
          crossDomain: true,
        },
        ...(localeDatasetDataTranslations
          ? {
              ns: [appTranslations, localeDatasetDataTranslations],
              fallbackNS: [localeDatasetDataTranslations],
            }
          : { ns: [appTranslations] }),
      },
      (err) => (err ? rej(err) : res(i18nInstance)),
    );
  });
}
